import React, { useCallback, useEffect, useState } from "react";
import { SGeneralForms } from "shj-components";
import {
  warningRulesGlobalProduct,
  warningRulesGlobalStore,
} from "@/services/product.ts";
import { useSetState } from "ahooks";
import styles from './index.module.less'
import { Spin } from "antd";

const GlobalRuleForm = ({reload}: {reload: boolean}) => {
  const [state, setState] = useSetState({
    orgList: [],
    productList: [],
    loading: false,
  })

  const getInfo = useCallback(async () => {
    try {
      setState({loading: true})
      await warningRulesGlobalStore().then(res => {
        setState({orgList: res.company})
      });
      await warningRulesGlobalProduct().then(res => {
        setState({productList: res.product})
      })
    } finally {
      setState({loading: false})
    }

  }, [setState])

  useEffect(() => {
    getInfo()
  }, [getInfo, reload]);

  const tagBoxRender = (data = [], key = 'name') => {
    return <div className={styles.tagBox}>
      {(data?.length <= 0 ? <div className={styles.empty}/> :
        data.map(item => <div className={styles.tag} key={item.id}>{item[key]}</div>)
      )}
    </div>
  }

  return <div>
    <Spin spinning={state.loading}>
      <SGeneralForms
        layout={'vertical'}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '查询门店',
              name: 'orgIds',
              children: () => tagBoxRender(state.orgList, 'companyName')
            },
            {
              spanCol: 24,
              label: '查询产品',
              name: 'productIds',
              children: () => tagBoxRender(state.productList, 'prodName')
            },
          ]
      }]}/>
    </Spin>
  </div>
}

export default GlobalRuleForm